import './bootstrap';
import {initPublicFreightsCreate} from "./freights/create";
import {afterComponentLoadBootstrap} from "./bootstrap";
import {initPublicFreightsAttachmentsView} from "./freights/attachments";
import {initPublicSignContractView} from "./freights/sign-contract";

const componentMap = {
	'default.freights.create': {
		action: initPublicFreightsCreate,
	},
	'default.freights.attachments': {
		action: initPublicFreightsAttachmentsView,
	},
	'default.freights.sign-contract': {
		action: initPublicSignContractView,
	},
};

// noinspection DuplicatedCode -- all bundles files share similar code
document.addEventListener('DOMContentLoaded', () => {
	// Init components
	if (window.jsComponents) {
		window.jsComponents.forEach(componentKey => {
			if (componentMap[componentKey]) {
				componentMap[componentKey].action();
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	afterComponentLoadBootstrap()
})
